import React from 'react'
// import { Typography } from '@mui/material'
// import LoginForm from '../../components/auth/login-form'
import NewPasswordForm from '../../components/account/new-password-form'

const NewPassword = () => {
    return (
        <>
            <NewPasswordForm />
        </>
    )
}

export default NewPassword
